import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";

import authReducer from "../core/auth/authSlice";
import msgReducer from "../core/auth/chatSlice";
import appReducer from "../core/auth/notifSlice";
import postReducer from "../core/auth/postSlice";

import errorReducer from "../core/errors/errorSlice";
import loadingReducer from "../core/loading/loadingSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    post: postReducer,
    app: appReducer,
    messages: msgReducer,
    errors: errorReducer,
    loading: loadingReducer,
  },
  devTools: process.env.NODE_ENV !== "production", // This line enables devtools
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
